import { NavLink as RouterNavLink } from 'react-router';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

export function NavLink({ to, children }: NavLinkProps) {
  return (
    <RouterNavLink
      to={to}
      className={({ isActive }) =>
        cn(
          'inline-flex h-14 items-center border-b-2 px-3 text-sm font-medium transition-colors',
          isActive
            ? 'border-primary text-foreground'
            : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
        )
      }
    >
      {children}
    </RouterNavLink>
  );
}
